import {useRef} from 'react'
import {MergeStatusButtonWrapper} from '../../components/MergeStatusButton'
import {DockedPanel, useDockedPanelActions} from '@github-ui/pull-requests/contexts/DockedPanelContext'
import {useSidebarMergeData} from './use-sidebar-merge-data'

export function SidebarMergeButton() {
  const {validatedMergeData} = useSidebarMergeData()
  const mergeStatusButtonRef = useRef<HTMLButtonElement>(null)
  const {togglePanel} = useDockedPanelActions()

  if (!validatedMergeData?.channels) return null

  return (
    <div className="pt-2">
      <MergeStatusButtonWrapper
        channels={validatedMergeData.channels}
        headSha={validatedMergeData.headSha}
        helpUrl={validatedMergeData.helpUrl}
        viewerLogin={validatedMergeData.viewerLogin}
        isDockedMode
        onToggleDockedPanel={() => togglePanel(DockedPanel.MergeStatus)}
        mergeStatusButtonRef={mergeStatusButtonRef}
      />
    </div>
  )
}
